<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UnitId"
      ref="list"
      unit="计量单位"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :query-params="params"
      :get-data-func="getDataFunc"
      :showTrendTable="showTrendTable"
      urlHash="basedata/inventory/unit"
      
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/ba/unit").default,
      params: {
        UnitName: "",
        Status: null,
      },
      unitPage: {},
    };
  },
  props: {
    showTrendTable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getDataFunc(params = {}) {
      return new Promise((resolve) => {
        this.api.list(params).then((res) => {
          resolve(res);
        });
      });
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.export(this.params).then(() => {
        loading.close();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
